<template>
  <div class="localidades-search-list">
    <b-row>
      <b-col cols="12" xl="12">
        <b-form>
          <b-form-group
            label="Nombre:"
            label-for="nombre"
            :label-cols="2"
            horizontal>
            <b-form-input 
              id="nombre" 
              v-model="nombre" 
              type="text">
            </b-form-input>
          </b-form-group>
        </b-form>
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <b-table hover  
            responsive="sm" 
            class="registro"
            :busy="tableBusy"
            :items="localidades" 
            :fields="localidadesFields"
            :filter="nombre"
            :filter-function="filter"
            :current-page="paginaActual"
            :per-page="registrosPorPagina"
            @filtered="onFiltered"
            @row-clicked="seleccionarLocalidad">
          <div slot="table-busy" class="text-center">
            <b-spinner class="table-spinner" label="Spinning" />
          </div>              
        </b-table>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" xl="12">  
        <nav>
          <b-pagination size="sm" 
            :total-rows="totalRegistros" 
            :per-page="registrosPorPagina" 
            v-model="paginaActual" 
            prev-text="Prev." next-text="Prox."/>
        </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>

export default {
  name: 'LocalidadesSearchList',
  data: () => {
    return {
      localidades: [],
      localidadesFields: [
        // {
        //   key: 'id',
        //   label: 'Cód.'
        // },
        {
          key: 'nombre',
          label: 'Localidad',
          sortable: true
        },
        {
          key: 'provincia',
        },
      ],

      loaded: false,
      tableBusy: false,
      /* Info de paginación */
      paginaActual: 1,
      totalPaginas: 1,
      registrosPorPagina: 5,
      totalRegistros: 0,

      nombre: null,
    }
  },
  computed: {
  },
  created() {
    this.getLocalidades()
  },  
  methods: {
    getLocalidades() {
      this.tableBusy = true;
      this.$store.dispatch('localidades/getList')
        .then(() => {
          this.localidades = this.$store.getters['localidades/list'];
          this.totalRegistros = this.localidades.length;
          this.tableBusy = false;
        })
    },
    seleccionarLocalidad (item) {
      this.$emit('localidadSeleccionada', item)
    },
    filter(row, nombre) {
      // console.log(row, nombre);
      return row.nombre.toUpperCase().trim().includes(nombre.toUpperCase().trim());
    },
    onFiltered(filteredItems) {
      this.totalRegistros = filteredItems.length
      this.paginaActual = 1
    }    
  },
}
</script>

<style>
  .localidades-search-list table td[aria-colindex="1"] {
    width: 70%;
  }
  .localidades-search-list table td[aria-colindex="2"] {
    width: 30%;
  }
  /* .localidades-search-list table td[aria-colindex="3"] {
    width: 30%;
  } */
</style>
